// extracted by mini-css-extract-plugin
export default {"gallerie_img_container":"gallerie_gallerie_img_container__4DCLd","gallerie_title":"gallerie_gallerie_title__2gih-","gallerie":"gallerie_gallerie__Extwg"};